import { render, staticRenderFns } from "./RelatedFiles.vue?vue&type=template&id=49029f04&scoped=true&"
import script from "./RelatedFiles.vue?vue&type=script&lang=js&"
export * from "./RelatedFiles.vue?vue&type=script&lang=js&"
import style0 from "./RelatedFiles.vue?vue&type=style&index=0&id=49029f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49029f04",
  null
  
)

export default component.exports